import { t } from "@/i18n-js/instance";

const i18nRoot = "pricing_plans.upgrade_modal";

export const getDisplaySubheading = (
  subheading: string,
  isEmailHubOnlyUpgrade?: boolean,
): string => {
  if (isEmailHubOnlyUpgrade) {
    return t("pricing_plans.upgrade_modal.email_hub_value_prop_title");
  }

  return subheading;
};

export const communityHubPlanDisplayName = (plan: any): string =>
  plan?.display_name || t([i18nRoot, "default_plan_name"]);

export const getDisplayName = (plan: any, marketingHubPlan: any): string =>
  plan?.display_name ||
  marketingHubPlan?.display_name ||
  t([i18nRoot, "default_plan_name"]);

export const getAmountWithCurrency = (plan: any): string => {
  const isPlanOnOffer = plan?.plan_coupon?.formatted_discount_percentage;
  return isPlanOnOffer
    ? plan?.plan_coupon?.discounted_monthly_price_with_currency || ""
    : plan?.amount_without_currency || "";
};

export const getDisplayIntervalText = (plan: any): string =>
  plan?.plan_coupon?.interval_abbreviation || plan?.interval_abbreviation || "";

export const getDiscountPercentage = (plan: any): string | null => {
  if (plan?.plan_coupon?.formatted_discount_percentage) {
    return plan.plan_coupon.formatted_discount_percentage;
  }
  return null;
};
